// The account slot on the landing screen.
//
// The hub is the identity provider — there is no form here, and there are no credentials in this
// bundle. Signing in means going to the hub, which launches the app back with a handoff token that
// only the server can verify.
//
// **Renders nothing at all when the hub is unconfigured**, which is the non-negotiable from
// PLAN.md: the game must be fully playable and demoable with zero hub config, and an account slot
// offering a sign-in that cannot work is worse than no slot.

export interface MeResponse {
  hub: boolean
  hubUrl: string
  user: { display_name?: string | null; username?: string | null; email?: string | null } | null
}

/** What to show for a given /api/me response, as data — so the decision is testable without a DOM. */
export function accountView(me: MeResponse): { html: string; visible: boolean } {
  if (!me.hub) return { html: '', visible: false }

  if (!me.user) {
    return {
      visible: true,
      html:
        `<a class="account-link" href="${me.hubUrl}">SIGN IN VIA LOOM &amp; SKULLCAP</a>` +
        `<p class="account-note">Scores post to the hub when you are signed in. The daily plays either way.</p>`,
    }
  }

  const name = me.user.display_name || me.user.username || me.user.email || 'SIGNED IN'
  return {
    visible: true,
    html:
      `<p class="account-note">Signed in as <span class="who">${escapeHtml(name)}</span></p>` +
      `<button id="account-signout" type="button" class="account-link">SIGN OUT</button>`,
  }
}

/** The user's own display name is not ours to trust — it round-trips through the hub and back. */
function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}

export async function mountAccount(el: HTMLElement, onChange: () => void): Promise<void> {
  let me: MeResponse
  try {
    const res = await fetch('/api/me')
    if (!res.ok) return
    me = (await res.json()) as MeResponse
  } catch {
    // No server (vite dev without dev:server), or it is down. The game does not depend on this.
    return
  }

  const view = accountView(me)
  el.innerHTML = view.html
  el.hidden = !view.visible

  el.querySelector('#account-signout')?.addEventListener('click', () => {
    void fetch('/auth/logout', { method: 'POST' }).then(onChange)
  })
}
